<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  assistantName: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();
const dialogRef = ref(null);
const typedName = ref('');

const nameMatches = computed(
  () => typedName.value.trim() === props.assistantName.trim()
);

const open = () => {
  typedName.value = '';
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const confirm = () => {
  if (!nameMatches.value || props.isLoading) return;
  emit('confirm');
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('ARROWS_AI.SETTINGS.DELETE.TITLE')"
    :description="
      t('ARROWS_AI.SETTINGS.DELETE.CONFIRM_DESCRIPTION', {
        assistantName,
      })
    "
    :confirm-button-label="t('ARROWS_AI.SETTINGS.DELETE.CONFIRM')"
    :disable-confirm-button="!nameMatches"
    :is-loading="isLoading"
    @confirm="confirm"
    @close="typedName = ''"
  >
    <Input
      v-model="typedName"
      :label="t('ARROWS_AI.SETTINGS.DELETE.NAME_LABEL')"
      :placeholder="t('ARROWS_AI.SETTINGS.DELETE.NAME_PLACEHOLDER')"
      autofocus
    />
  </Dialog>
</template>
